import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { fromEvent, merge, Observable, of, Subject } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import {
    AfterViewInit,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID
} from '@angular/core';
import {
    FuseConfigService,
    TemplateAtlasSharedService
} from '@ecap3/template-atlas';
import {
    EcapCoreAnalyticsService,
    EcapLoginService,
    EcapTranslateService,
    getCurrentLanguage as GetCurrentLanguage,
    NavigationProvider,
    ShellDomainProvider,
    State,
    UserInfoService
} from '@ecap3/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { routes } from '../routes';
import { navigations } from '../navigations';
import { isPlatformServer, Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { UpdateService } from '../service/updateSw';
import { TitleService } from '../service/title.service';
import { FuseAboutComponentDynamic } from '../../fuse/about-dynamic/about.component';
import { SLSNToolbarComponent } from 'src/app/fuse/toolbar/toolbar.component';
// import { FuseQuickPanelComponent } from 'src/app/fuse/quick-panel/quick-panel.component';
import { NavbarVerticalStyle2Component } from '../../fuse/navbar/app-navbar.component';
// import { NotFoundComponent } from '../not-found/not-found.component';
import { SharedService } from '../../shared/services/shared.service';
// import { Guid } from 'guid-typescript';
import { AppNotificationListComponent } from 'src/app/business/app-notification/components/app-notification-list/app-notification-list.component';
import { SignalrNotificationService } from '@ecap3/signalr-notification';
import { DeltaGqlService } from 'src/app/shared/services/delta-gql.service';
import { DELTA_CONFIG } from 'src/app/delta-config/constant/delta-config.constant';
import { deepSafeAccess } from 'src/app/shared/helpers/deep-safe-access';

@Component({
    selector: 'app-root-default',
    templateUrl: './root-default.component.html',
    styleUrls: ['./root-default.component.scss']
})
export class RootDefaultComponent implements OnInit, OnDestroy, AfterViewInit {
    TenantLogo: any =
        ShellDomainProvider['api'] &&
        ShellDomainProvider['api']['CdnTenantBaseUrl'] +
            'assets/swisslife-logo-horizontal.svg';
    apps: any[];
    navigations: any[];
    routeData: any;
    public toolbarComponent: any;
    public quickPanelComponent: any;
    dialogRef: any;
    language = new Subject<string>();
    lang$: Observable<string>;
    // public customerHouseholdListComponent : any;
    // public verticalNavbarComponent: any;
    private _unsubscribeAll: Subject<any>;
    isPlatformServer: any;
    userSelectedFeatures: any;
    pullEnabled = false;
    targetElement: Element;
    navbarComponent: any;

    constructor(
        private location: Location,
        private update: SwUpdate,
        private router: Router,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private fuseConfig: FuseConfigService,
        private matSnackBar: MatSnackBar,
        private ecapTranslateService: EcapTranslateService,
        private templateAtlasSharedService: TemplateAtlasSharedService,
        private sharedService: SharedService,
        private navigationProvider: NavigationProvider,
        private userInfo: UserInfoService,
        private translationService: TranslateService,
        private swUpdateService: UpdateService,
        private titleService: TitleService,
        private loginService: EcapLoginService,
        @Inject(PLATFORM_ID) platformId: string,
        private ecapCoreAnalyticsService: EcapCoreAnalyticsService,
        private store: Store<State>,
        private signalrNotificationService: SignalrNotificationService,
        private gqlService: DeltaGqlService
    ) {
        router.initialNavigation();
        this.ecapCoreAnalyticsService.initializeAnalytics();
        this.isPlatformServer = isPlatformServer(platformId);
        this.navigationProvider.setCurrentNavigations(navigations);
        this._unsubscribeAll = new Subject();
        this.ecapTranslateService.initLang();
        this.lang$ = this.store.select(GetCurrentLanguage);
        this.swUpdateService.checkForUpdates();
        this.apps = routes;
        this.navigations = navigations;

        this.router.events
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    const currentApp =
                        this.activatedRoute.root.firstChild.snapshot; // Need to better approch for get current route
                    const hideTemplateNavigations =
                        currentApp && currentApp.data
                            ? currentApp.data.isFullScreen
                            : true;
                    if (!hideTemplateNavigations) {
                        this.fuseConfig.setConfig({
                            colorTheme: 'theme-ecap',
                            customScrollbars: true,
                            workingDomain: 'RHEA 2.0',
                            layout: {
                                style: 'vertical-layout-1',
                                width: 'fullwidth',
                                navbar: {
                                    primaryBackground: 'nav-primaryBackground',
                                    secondaryBackground:
                                        'nav-secondaryBackground',
                                    // background: 'mat-arc-primary-50-bg',

                                    folded: false,
                                    hidden: false,
                                    userNameShow: true,
                                    designationShow: true,
                                    position: 'left',
                                    variant: 'vertical-style-dynamic',
                                    dynamicVarientComponent:
                                        this.navbarComponent,
                                    navbarTop: 'spp-nav-tool',
                                    topMenu: {
                                        showMyAccount: false,
                                        showAbout: false,
                                        showMemory: false,
                                        showLogout: false,
                                        logoutIcon: 'exit_to_app',
                                        newMenuList: [
                                            {
                                                icon: 'account_circle',
                                                text: 'MY_ACCOUNT',
                                                callEvent:
                                                    this.openMyAccountModal
                                            },
                                            {
                                                icon: 'info',
                                                text: 'ABOUT_TEXT',
                                                callEvent: this.goMyAboutPage
                                            },
                                            // { icon: 'memory', text: 'NAVBAR.REPORT_ISSUE', callEvent: this.openReportModal },
                                            {
                                                icon: 'exit_to_app',
                                                text: 'LOGOUT_TEXT',
                                                callEvent: this.logOut
                                            }
                                        ]
                                    }
                                },
                                toolbar: {
                                    logo:
                                        ShellDomainProvider['api'] &&
                                        ShellDomainProvider['api'][
                                            'CdnTenantBaseUrl'
                                        ] +
                                            'assets/swisslife-logo-horizontal.svg',
                                    background: 'mat-arc-primary-bg',
                                    customBackgroundColor: true,
                                    hidden: false,
                                    position: 'below-fixed',
                                    component: {
                                        shortcuts: false,
                                        search: false,
                                        userInfo: false,
                                        sudebar: false,
                                        languageMenu: {
                                            show: true,
                                            showLearnMore: false,
                                            showFlag: false,
                                            languageList: [
                                                {
                                                    id: 'en',
                                                    title: 'English',
                                                    flag: 'us'
                                                },
                                                {
                                                    id: 'de',
                                                    title: 'German',
                                                    flag: 'de'
                                                }
                                            ]
                                        }
                                    },
                                    breadcrumb: false
                                },
                                footer: {
                                    background: 'mat-grey-A100-bg',
                                    hidden: true,
                                    position: 'below-static'
                                },
                                sidepanel: {
                                    hidden: true,
                                    position: 'right'
                                },
                                floatingChatPanelConfig: {
                                    admin: {
                                        showChatPanel: true,
                                        onlyNotification: true
                                    }
                                },
                                notificationQueryPayload: {
                                    ResponseKeys: [
                                        'MessagingThreadNotification'
                                    ],
                                    ResponseKeyFilterOperator: 'NotIn',
                                    OnlyUnread: false,
                                    OrderByCreatedDate: 1,
                                    ReturnCount: true,
                                    PageNumber: 1,
                                    PageSize: 100
                                },
                                onlyMessageQueryPayload: {
                                    ResponseKeys: [
                                        'MessagingThreadNotification'
                                    ],
                                    ResponseKeyFilterOperator: 'In',
                                    OnlyUnread: true,
                                    OrderByCreatedDate: 1,
                                    ReturnCount: true,
                                    PageNumber: 1,
                                    PageSize: 100
                                },
                                breadcrumb: false
                            },
                            app: {
                                login: {
                                    loginformTopLogo:
                                        'https://cdn.selise.biz/swisspartners/Logo/logo_login_256.png'
                                }
                            }
                        });
                    } else {
                        this.fuseConfig.resetToDefaults();
                    }
                }
            });
        this.updateClient();
    }

    online$: Observable<boolean>;
    logOut = () => {
        this.loginService.logoutFromPlatform();
    };

    resolveComp() {
        this.toolbarComponent = SLSNToolbarComponent;
        this.quickPanelComponent = AppNotificationListComponent;
        this.navbarComponent = NavbarVerticalStyle2Component;
    }

    logoutRouteUpdate() {
        const index = this.navigations.findIndex(
            (nav) => nav.url === '/logout'
        );
        this.navigations[index].function = this.logOut;
    }

    subscribeToWrapperEvent(): void {
        globalThis.addEventListener('load', (event) => {
            setTimeout(() => {
                (globalThis as any).nsWebViewBridge.on(
                    'eventFromWrapper',
                    (msg: any) => {
                        console.log(msg);
                        this.sharedService.isFirstEventFromWrapper.next(true);
                    }
                );
            }, 10);
        });
    }

    toolbarData = null;
    ngOnInit() {
        this.sharedService.toolbarSubject.subscribe(
            (data: { title: string; route: string }) => {
                // debugger;
                // console.log(data);
                this.toolbarData = data;
            }
        );

        //    this.subscribeToWrapperEvent();
        this.logoutRouteUpdate();
        this.targetElement = document.querySelector('html');
        // this.userInfo.currentUserFirstTimeLogin
        // .pipe(takeUntil(this._unsubscribeAll))
        // .subscribe((currentUserResponse: any) => {

        //     // this.featureProvider.getFeatures().then((response: any) => {
        //     //     debugger;
        //     //     this.userSelectedFeatures = response.length?response.map('Name'):[];
        //     //     debugger;
        //     // });
        // tslint:disable-next-line:max-line-length
        //     if (currentUserResponse && currentUserResponse['PersonId'] && currentUserResponse['LogInCount']===1 && this.cookieService.check('isNewOrganiztionSignedup')) {
        //         this.cookieService.delete('isNewOrganiztionSignedup');
        //         this.router.navigateByUrl('/setup');
        //     }
        // });
        this.titleService.init();
        this.resolveComp();
        if (!this.isPlatformServer) {
            this.online$ = merge(
                of(navigator.onLine),
                fromEvent(globalThis, 'online').pipe(map(() => true)),
                fromEvent(globalThis, 'offline').pipe(map(() => false))
            );
            this.online$
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((response) => {
                    if (!response) {
                        const message =
                            this.ecapTranslateService.instantTranslate(
                                'INTERNET_UNAVAILABLE'
                            );
                        this.matSnackBar.open(message, '', {
                            duration: 2000,
                            verticalPosition: 'bottom',
                            horizontalPosition: 'end',
                            panelClass: 'custom-snackbar'
                        });
                    } else {
                        this.matSnackBar.dismiss();
                    }
                });
        }
        
        this.lang$.subscribe((lang) => {
            this.translationService.use(lang);
            // tslint:disable-next-line:no-unused-expression
            globalThis['supportITSM']?.emitEvent({
                locale: lang
            });
        });
        // ========================================================
        // setting configuration for entitybased chat directive
        // According to this entitybasedChat directive will take
        // decision how it will open chat box
        // ========================================================

        this.userInfo.currentUser
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result.IsSuccess && result.Email) {
                    const userInfo = {
                        name: result['DisplayName'],
                        email: result['Email'],
                        isLoggedIn: true
                    };
                    // tslint:disable-next-line:no-unused-expression
                    if(globalThis['supportITSM']){
                        globalThis['supportITSM'].emitEvent({ config: userInfo });
                    }
                    
                    if(result.UserId){
                        const message = JSON.stringify({
                            action: 'userInfo',
                            data: {
                                action: 'userLogin', 
                                userId: result.UserId 
                            }
                        });
                        if ((globalThis as any).FlutterBridge) {
                            console.log("[userInfo] FlutterBridge detected.");
                            (globalThis as any).FlutterBridge.postMessage(message);
                        }
                    }
                    if(result.PersonId){
                        this.checkIfEmployeeIsSubContractor(result.PersonId);
                    }
                }
                // if (result.IsSuccess && result.Email && result.Roles.indexOf('companyadmin') > -1) {
                //     this.featureProvider.getFeatures().then((response: any) => {
                //         if (!this.hasFeature(response, 'arc-customer')) {
                //             this.router.navigate(['/setup']);
                //         }
                //     });
                // }
            });

        this.templateAtlasSharedService.openAboutModal
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                    this.dialogRef = this.dialog.open(
                        FuseAboutComponentDynamic,
                        {
                            width: '720px',
                            maxWidth: '100vw',
                            panelClass: 'custom-dialog'
                        }
                    );

                    this.dialogRef
                        .afterClosed()
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((result2) => {});
                }
            });
    }

    private checkIfEmployeeIsSubContractor(personId: string) {
        this.gqlService.getEntityData(
            DELTA_CONFIG.Entity.DeltaEmployee,
            ['ItemId', 'IsSubContractor'],
            `PersonId: '${personId}'` 
        )
        .pipe(take(1))
        .subscribe(res=> {
            if (res && res.Data && res.Data.length && res.Data[0].IsSubContractor) {
                this.logOut();
            }
        })
    }

    clickBackBtn() {
        console.log('back button clicked');
        if (
            this.router.url === '/' ||
            this.router.url === '/home' ||
            this.router.url === '/iam' ||
            this.router.url === '/login'
        ) {
            const nsWebViewBridge = (globalThis as any).nsWebViewBridge;
            nsWebViewBridge.emit('closeAppEvent', { msg: 'close' });
        } else {
            console.log('inside location back/router navigate');
            // this.location.back();
            if (this.toolbarData) {
                this.router.navigate(
                    [this.toolbarData.route],
                    this.toolbarData.queryParam
                );
            } else {
                this.location.back();
            }
        }
    }

    setStatusBarHeight(heightInPercentage) {
        console.log("StatusBarHeight in Percentage from webview: ", heightInPercentage);
        this.sharedService.setStatusBarHeight(heightInPercentage);
    }

    isAndroid = false;
    isIPhone = false;
    ngAfterViewInit(): void {
        this.isAndroid = /android/i.test(navigator.userAgent);
        this.isIPhone = /iPhone|iPod|iPad|macintosh/i.test(navigator.userAgent);
        if (this.isAndroid) {
            console.log('android device');
        } else {
            console.log('iOS device');
            const message = JSON.stringify({
                action: 'statusBarInfo',
                data: { msg: 'Height' }
            });

            if ((globalThis as any).FlutterBridge) {
                (globalThis as any).FlutterBridge.postMessage(message);
            }
        }
        const allowedOrigins = [
            'file://',
            'null', // Some WebViews report this
            'http://localhost:4200',
            'https://deltamobile.seliselocal.com',
            'https://deltamobile.selisestage.com',
            'https://my.deltagroup.cloud'
        ];
        // event listener from Flutter
        globalThis.addEventListener('message', (event: any) => {
            if (!allowedOrigins.includes(event.origin)) {
                return;
            }
            
            const msg = event.data;
            
            if (!deepSafeAccess(msg, ['type'])) return;

            switch (msg.type) {
            case 'reconnectWebSocket':
                this.sharedService.sendChatInboxCloseEvent();
                this.sharedService.reconnectWebSocket();
                this.signalrNotificationService.wasOffline = true;
                this.signalrNotificationService.reconnectNotification();
                break;

            case 'syncEvents':
                this.matSnackBar.open("Events synced successfully.", "x", { duration: 2000, panelClass: 'custom-snackbar' });
                break;
            case 'statusBarEvent':
                this.setStatusBarHeight(msg.statusBarHeight);
                break;
            }
        });
    }

    openMyAccountModal = () => {
        this.router.navigate(['/account']);
    };
    goMyAboutPage = () => {
        this.dialogRef = this.dialog.open(FuseAboutComponentDynamic, {
            width: '720px',
            maxWidth: '100vw',
            panelClass: 'custom-dialog'
        });

        this.dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                // console.log('The dialog was closed');
            });
    };

    private hasFeature(featureList: Array<any>, featureName: string) {
        let isContainFeature = false;
        if (featureList && featureList.length) {
            featureList.forEach((feature) => {
                // tslint:disable-next-line:triple-equals
                if (!isContainFeature && feature.Name == featureName) {
                    isContainFeature = true;
                }
            });
        }
        return isContainFeature;
    }

    public getCurrentApp(url) {
        for (const app of this.apps) {
            if (app.path === url.split('?')[0].slice(1)) {
                return app;
            }
        }
        return;
    }

    ngOnDestroy() {
        console.log('destroyed root default!');

        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    refreshPage(event: Subject<any>, message: string) {
        location.reload();
        event.next(null as any);
    }

    updateClient() {
        if (!this.update.isEnabled) {
            console.log('Not Enabled');
            return;
        }
        this.update.versionUpdates
            .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe((event) => {
                console.log(`current`, event.currentVersion, `available`, event.latestVersion);
                globalThis.location.reload();

                this.matSnackBar.open('Update available for the app please confirm', 'OK', {
                    verticalPosition: 'bottom',
                    horizontalPosition: 'end',
                    panelClass: 'custom-snackbar'
                }).onAction().subscribe(()=>{
                    this.update.activateUpdate().then(() => location.reload());
                });
            });
    }

    /**
	 * Central Translation
	 * IF translation loads centrally from a single module 
	 * then we heave to fetch new translations when user clicks to the reload button
	 * This method triggers when user clicks reload button on the browser
	 */
	addAfterReloadOperations(): void {
		if(!ShellDomainProvider['api'].loadTranslationsCentrally) return;

		const [navigation] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];

		if (navigation && navigation.type === 'reload') {
			sessionStorage.removeItem('de');
			sessionStorage.removeItem('it');
			sessionStorage.removeItem('en');
    	}
	}
}
